(function ($, window, undefined) {
	'use strict';

	/**
	 * [FormSteps - Fun��o que faz a valida��o de passo a passo]
	 * @param {string} element [Representa o seletor que do formulario]
	 */
	App.FormSteps = function (element) {
		this.element = $(element);
		this.containerForm = $(element).closest('.carousel').width();
		this.total = $(element).find('fieldset').length;
	};

	/* Inicia a fun��o chamando o primeiro �ndice */
	App.FormSteps.prototype.init = function () {
		this.goto(0);
	};

	/**
	 * M�todo para realizar navega��o entre os fieldsets
	 * @param  {[type]} index [description]
	 * @return {[type]}       [description]
	 */

	App.FormSteps.prototype.goto = function (index) {

		index = index < this.total ? index : 0;

		

		this.element.stop().animate({
			'left': index * this.containerForm * (-1) // Calcular a posi��o do proximo elemento
		}, 1000, 'easeInOutExpo', function () {
			$(this).clearQueue();
		});

		this.setActiveByIndex(index);

		this.goBack(index);
	};

	/**
	 * Fun��o para obter a altura do fieldset ativo 
	 * @param {[int]} index - posicao do indice atual
	 */
	App.FormSteps.prototype.getCurrentHeight = function (index) {
	    //console.log(index);
		var carouselHeight = $('.box-trabalhe-conosco').find('.carousel').height(),
			formContainerHeight = $('.form-container:eq(' + index + ')').height(),
			defaultDistance = 30;

		var currentHeight = parseInt((carouselHeight - formContainerHeight) * -1);

		setTimeout(function () {
			$('.form-steps').css({
				//'transform': 'translateY(' + (currentHeight + defaultDistance) + 'px)'
			});
		}, 500);
	};

	/**
	 * Fun��o que marca os elementos ativos
	 * @param {[type]} index [description]
	 */
	App.FormSteps.prototype.setActiveByIndex = function (index) {
		$('.form-tabs a, .form-container, .form-step-item').removeClass('active');
		$('.form-tabs li:visible a:eq(' + index + '), .form-container:visible:eq(' + index + '), .form-step-item:visible:eq(' + index + ')').addClass('active');
	};

	/**
	 * Fun��o para fazer a pagina��o em containers j� preenchidos
	 * @param  {[type]} index [description]
	 * @return {[type]}       [description]
	 */
	App.FormSteps.prototype.navAction = function (index) {
		/*
		 * Faz as a��es da pagina��o:
		 * Verifica se o �ndice � menor que o ativo
		 * e habilita somente para voltar
		 */

		if (index < $('.form-container.active').index()) {
			this.goto(index);
		} else {
			$('.form-container').eq(index - 1).addClass('active');

			if ($('.form-trabalhe-conosco').validate('isvalid')) {
				this.goto(index);
			} else {
				$('.form-container').eq(index).removeClass('active');
			}
		}

		// Botao voltar
		this.goBack(index);
	};

	/**
	 * Fun��o que mostra a porcentagem atual dos elementos preenchidos
	 */
	App.FormSteps.prototype.showPercentageOfSteps = function () {
		var formItems = $('.form-trabalhe-conosco').serializeArray(),
			formNew = [];
		$.each(formItems, function (index, element) {
			if (element.value !== '') {
				formNew.push(element);
			}
		});
		// Calcular a porcentagem
		var porcentagem = Math.floor(formNew.length * 100 / formItems.length);
		$('.form-step-level b').text(porcentagem);
	};

	/**
	 * Fun��o para mostrar ou esconder o bot�o voltar
	 */
	App.FormSteps.prototype.goBack = function (index) {
		var $botaoVoltar = $('.form-steps').find('.prev-step');

		(index > 0) ? $botaoVoltar.removeAttr('disabled') : $botaoVoltar.attr('disabled', 'disabled');
	};

})(jQuery, window);